<template>
  <v-hover>
    <template v-slot:default="{ props, hover }">
      <v-btn
        icon
        dense
      >
        <v-icon
          v-bind="props"
          :color="hover ? 'primary' : state ? 'orange' :undefined"
          @click="onClickIcon"
        >
          {{ state ? 'mdi-chevron-down-circle' : 'mdi-chevron-up-circle' }}
        </v-icon>
      </v-btn>
    </template>
  </v-hover>
</template>


<script>
    import event_bus from "../../store/event_bus";

    export default {
      name: "IconDropDown",

      props: {
        init_state: {
          type: Boolean,
          required: true,
          default: false
        },

        event_name: {
          type: String,
          required: true
        },
      },

      data() {
        return {
          iconName: 'mdi-chevron-up-circle',
          state: this.init_state,
        };
      },

      watch: {},

      computed: {},

      methods: {
        onClickIcon() {
          this.state = !this.state

          if (event_bus) {
            event_bus.$emit(`${this.event_name}`)
            // console.log(`emit ${this.state} on ${this.event_name}`)
          }
        }
      },

    }
</script>

<style scoped />